export default __webpack_public_path__ + "static/media/login_3.746f0188.jpg";